const QA_DASHBOARD_GRAPHQL_PATH = '/api/qa-dashboard-graphql'
const LOCAL_HOSTNAMES = new Set(['127.0.0.1', 'localhost'])

export const browserGraphqlEndpoint = (
  endpoint,
  browser = typeof window !== 'undefined'
) => {
  if (!browser || typeof endpoint !== 'string') return endpoint

  try {
    const target = new URL(endpoint)
    if (
      target.protocol === 'http:' &&
      LOCAL_HOSTNAMES.has(target.hostname) &&
      target.pathname === QA_DASHBOARD_GRAPHQL_PATH
    ) {
      return `${target.pathname}${target.search}${target.hash}`
    }
  } catch {
    return endpoint
  }

  return endpoint
}
